import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';

interface IColoredToggleButtonProps {
  id: string;
  className?: string;
  value: boolean;
  isDisabled: boolean;
  iconName: string;
  labelKey: IntlKey;
  e2e?: string;
  iconPosition?: 'left' | 'right';

  onValueChanged: (value: boolean) => void;
}

export const ColoredToggleButton: FC<IColoredToggleButtonProps> = ({
  id,
  iconName,
  labelKey,
  onValueChanged,
  className,
  value,
  isDisabled,
  e2e,
  iconPosition = 'left',
}) => {
  const { formatMessage } = useIntl();
  const label = formatMessage({ id: labelKey });
  const onToggled = useCallback(() => onValueChanged(!value), [value, onValueChanged]);

  return (
    <button
      type="button"
      id={id}
      className={classNames('btn btn-icon-start', className, {
        'btn-flat-info': value,
        'btn-flat-secondary': !value,
      })}
      onClick={onToggled}
      data-e2e={e2e}
      data-is-toggled={value}
      disabled={isDisabled}
    >
      {iconPosition === 'left' && <i className="icon">{iconName}</i>}
      <div className="d-none d-xxl-flex">{label}</div>
      {iconPosition === 'right' && <i className="icon">{iconName}</i>}
    </button>
  );
};

ColoredToggleButton.displayName = 'ColoredToggleButton';
